// login
export const commonAction = {
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAIL',
};
export const authType = {
  SUCCESS: 'AUTH_LOGIN',
  FAILURE: 'AUTH_FAILURE',
  LOGOUT: 'AUTH_LOGOUT',
};

export const walletConnection = {
  SUCCESS: 'WALLET_CONNECT_SUCCESS',
  FAILURE: 'WALLET_CONNECT_FAILURE',
  DISCONNECT: 'WALLET_DISCONNECT',
};

export const commonConfig = {
  SUCCESS: 'IPFS_CONFIG_SUCCESS',
  FAILURE: 'IPFS_CONFIG_FAILURE',
};
